import { render, staticRenderFns } from "./dbFile.vue?vue&type=template&id=10c40118&scoped=true&"
import script from "./dbFile.vue?vue&type=script&lang=js&"
export * from "./dbFile.vue?vue&type=script&lang=js&"
import style0 from "./dbFile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dbFile.vue?vue&type=style&index=1&id=10c40118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c40118",
  null
  
)

export default component.exports